// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3bXRW","header":"PatientQuestionnaire_header__1e6rN","info":"PatientQuestionnaire_info__3aMFC"};